// src/components/TaskDescriptionEditor.tsx
import React, { useState } from "react";

interface Props {
  description: string;
  onSave: (newDescription: string) => void;
}

export default function TaskDescriptionEditor({ description, onSave }: Props) {
  const [editing, setEditing] = useState<boolean>(false);
  const [value, setValue] = useState<string>(description ?? "");

  // keep value in sync if parent passes new props
  React.useEffect(() => setValue(description ?? ""), [description]);

  if (!editing) {
    return (
      <p onDoubleClick={() => setEditing(true)} style={{ cursor: "pointer", marginTop: 8 }}>
        {description || <i >Click to add description (double-click)</i>}
      </p>
    );
  }

  return (
    <div style={{ marginTop: 8 }}>
      <textarea value={value} onChange={(e) => setValue(e.target.value)} rows={3} style={{ width: "100%" }} />
      <div style={{ marginTop: 6 }}>
        <button onClick={() => { onSave(value); setEditing(false); }}>Save</button>
        <button onClick={() => { setValue(description ?? ""); setEditing(false); }} style={{ marginLeft: 8 }}>Cancel</button>
      </div>
    </div>
  );
}
